// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3hZqj","productName":"Table_productName__16eKN"};